"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = User;

var _User = require("@adobe/react-spectrum-workflow/dist/User");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function User(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_User.A4uUser, null));
}